/**
 * Like pluck, but it plucks from each thing in a list.
 */

import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

export function pluckList<T, P1 extends keyof T>(
  property1: P1,
): ((
  source: Rx.Observable<ReadonlyArray<T>>,
) => Rx.Observable<ReadonlyArray<T[P1]>>) {
  return map(xs => xs.map(x => x[property1]));
}
